import { gql } from "apollo-boost";

export const MANY_YOUDAO = gql`
  query($ids: [String!]!) {
    manyYoudao(ids: $ids) {
      title
      id
      abstract {
        text
        label
      }
      keywords
    }
  }
`;
